import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EnvironmentsService } from '@feedback/shared/services/environments.service';
import { TranslateService } from '@ngx-translate/core';
import { ChunkRecoveryService } from '@shared/services/chunk-recovery.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private readonly _environments: EnvironmentsService,
    private readonly _translate: TranslateService,
    _chunkRecovery: ChunkRecoveryService // eager-instantiate so Router NavigationError subscription runs
  ) {
    const lng = 'en';
    this._translate.setDefaultLang(lng);
    this._translate.use(lng);

    this._environments.setScripts();
  }

  ngOnInit(): void {}
}
